module.exports = __webpack_public_path__ + "img/3.c6420f0b.png";